import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Grid, Input } from 'antd';
import styles from './headerNavigator.module.less';
const dataPlaceholder = ['Cari program hamil...', 'Cari tips kehamilan...', 'Cari tumbuh kembang anak...', 'Cari resep...', 'Cari MPASI...'];
const SearchInput = () => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isAnimating] = useState(true);
  const {
    xs
  } = Grid.useBreakpoint();
  const router = useRouter();
  const animationTimeoutRef = useRef<number | null>(null);
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };
  const handlePressEnter = async () => {
    const queryParams = new URLSearchParams({
      name: inputValue
    }).toString();
    router.push(`/search?${queryParams}`);
  };
  const startAnimationForCurrentItem = () => {
    if (!isAnimating) return;
    const currentItem = dataPlaceholder[currentItemIndex];
    let charIndex = 0;
    const currentLength = currentItem.length;
    const startDeleting = () => {
      if (!isAnimating) return;
      let deleteIndex = currentLength;
      const deleteChar = () => {
        if (!isAnimating || deleteIndex <= 0) {
          setCurrentText('');
          animationTimeoutRef.current = window.setTimeout(() => {
            const nextIndex = (currentItemIndex + 1) % dataPlaceholder.length;
            setCurrentItemIndex(nextIndex);
          }, 500);
          return;
        }
        setCurrentText(currentItem.substring(0, deleteIndex - 1));
        deleteIndex--;
        animationTimeoutRef.current = window.setTimeout(deleteChar, 150);
      };
      deleteChar();
    };
    const startPause = () => {
      if (!isAnimating) return;
      animationTimeoutRef.current = window.setTimeout(() => {
        startDeleting();
      }, 1500);
    };
    const typeChar = () => {
      if (!isAnimating || charIndex >= currentLength) {
        setCurrentText(currentItem);
        startPause();
        return;
      }
      setCurrentText(currentItem.substring(0, charIndex + 1));
      charIndex++;
      animationTimeoutRef.current = window.setTimeout(typeChar, 150);
    };
    typeChar();
  };
  useEffect(() => {
    if (isAnimating && currentItemIndex >= 0) {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
      startAnimationForCurrentItem();
    }
  }, [currentItemIndex]);
  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
    };
  }, []);
  return <div style={{
    textAlign: 'center',
    marginTop: xs ? '5px' : '-5px',
    marginRight: xs ? '0px' : '15px'
  }}>
			<Input.Group compact>
				<Input style={{
        width: 'calc(80% - 40px)',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        textAlign: 'left',
        transition: 'opacity 0.3s ease-in-out'
      }} placeholder={currentText} onChange={handleInputChange} onPressEnter={handlePressEnter} />
				<Button className={styles.btnPrimary} onClick={handlePressEnter} style={{
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px'
      }}>
					<SearchOutlined />
				</Button>
			</Input.Group>
		</div>;
};
export default SearchInput;